import {
  Box,
  Button,
  CardMedia,
  Grid,
  Badge,
  IconButton,
  Pagination,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Menu,
  Skeleton,
  Switch,
  Select,
  MenuItem,
} from '@mui/material';
import { CommonLayout, CustomTablePaginationActions } from '../commonComponents';
import { SubHeading } from './components';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import AddIcon from '@mui/icons-material/Add';
import { useHistory } from 'react-router';
import { ChangeEvent, useEffect, useState } from 'react';
import {
  getAllApplications,
  getStampPaperCount,
  getLowStamPaperNotification,
  lowStampPaperNotification,
  getAllApplicationsWithCursor,
} from '../../redux-store/actions/application';
import { useDispatch, useSelector } from 'react-redux';
import { FilterDropdown, initialFilters } from './filters';
import {
  Distributor,
  DistributorFilterList,
  getDistributorsFilterListing,
  getDistributorsListForFilters,
} from '../../redux-store/actions';
import {
  ApplicationFilterType,
  GetLowStamPaperNotificationType,
} from '../../redux-store/types/api-types';
import {
  ApplicationProps,
  StampPapersType,
  stampPaperProp,
} from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import React from 'react';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  APPLICATION_LISTING_CHECKER_STATUS,
  APPLICATION_LISTING_STATUS,
  CursorDirection,
  paginateCursor,
  ROWS_PER_PAGE_OPTIONS,
  USER_ROLES,
} from '../../utils/constant';
import { useDebounce } from '../../utils/useDebounce';
import DashboardAndApplicationsList from '../dashboard/applicationslist';
import { Formik } from 'formik';
import MFCheckbox from '../../lib/formik/Checkbox';
import { useSnackbar } from 'notistack';
import Tooltip from '@mui/material/Tooltip';
import { SelectChangeEvent } from '@mui/material/Select';
interface Values {
  pan: string;
}
const FilterMenu = (): JSX.Element => {
  const initialValues1: Values = { pan: '' };
  const handleSubmit = (values: Values) => {
    console.log(values);
  };
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Formik initialValues={initialValues1} onSubmit={handleSubmit}>
      {({ handleSubmit }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <IconButton
            sx={{ p: 0 }}
            id="filter-button"
            aria-controls="filter-menu"
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}>
            <CardMedia component="img" src="/images/filter-icon.svg" alt="Filter" />
          </IconButton>
          <Menu
            id="filter-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'filter-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '.MuiPaper-root': { p: 2, pt: 1 },
              '.MuiTypography-root': {
                fontFamily: 'Poppins, sans-serif',
                fontSize: 14,
                '&.MuiTypography-body2': { color: 'primary.main', mb: 1 },
              },
              '.MuiBox-root:not(:last-of-type)': {
                position: 'relative',
                mr: 5,
                '::after': {
                  content: '""',
                  position: 'absolute',
                  top: 10,
                  right: -15,
                  width: '2px',
                  height: '100%',
                  background:
                    'linear-gradient(to bottom, rgba(0, 0, 0, 0.2),rgba(255, 255, 255, 0) )',
                },
              },
            }}>
            <Stack direction="row">
              <Box>
                <Typography component="h3" variant="body2">
                  Mode of holding
                </Typography>
                <MFCheckbox name="single" label="Single" />
                <MFCheckbox label="joint" name="Joint" />
              </Box>
              <Box>
                <Typography component="h3" variant="body2">
                  Status
                </Typography>
                <MFCheckbox name="Draft" label="Draft" />
                <MFCheckbox name="in-process" label="In Process" />
                <MFCheckbox name="completed" label="Completed" />
              </Box>
              <Box>
                <Typography component="h3" variant="body2">
                  Distributor Name
                </Typography>
                <MFCheckbox name="distributor-name1" label="Distributor Name 1" />
                <MFCheckbox name="distributor-name2" label="Distributor Name 2" />
              </Box>
            </Stack>
          </Menu>
        </Box>
      )}
    </Formik>
  );
};
function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12}>
      {children}
    </Grid>
  );
}

export default function Investors(): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false);
  const [applicationsList, setApplicationsList] = useState<ApplicationProps[]>([]);
  const [noOfPages, setNoPages] = useState(1);
  const [stampCount, setStampCount] = useState<stampPaperProp[]>([]);
  const [notificationEnabled, setNotificationEnabled] = useState(false);
  const {
    page,
    search: storeSearch,
    status: storeStatus,
    applicationType: storeApplicationType,
    modeOfHolding: storeModeOfHolding,
    distributorId: storeDistributorId,
    isSTPApplicable: storeSTPApplicable,
    amcApproverStatus,
    applicationSentBack,
    kycModified: storeKycModified,
    sortDirection: storeSortDirection,
    rowsPerPage: storeRowsPerPage,
    nextCursor: storeNextCursor,
    prevCursor: storePrevCursor,
    cursorDirection: storeCursorDirection,
    hasNext: storeHasNext,
    hasPrev: storeHasPrev,
    currentCursor: storeCurrentCursor,
  } = useSelector((store: RootStateType) => store.paramsObj);
  const [currentPage, setPage] = useState(page);
  const [open, setOpen] = useState(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<boolean>(false);
  const [distributors, setDistributors] = useState<DistributorFilterList[]>([]);
  const [filters, setFilters] = useState<ApplicationFilterType>(
    initialFilters(
      role,
      APPLICATION_LISTING_CHECKER_STATUS[amcApproverStatus || ''] ===
        APPLICATION_LISTING_CHECKER_STATUS.pending
        ? storeStatus.includes('sent_to_amc_approver')
          ? applicationSentBack
            ? storeStatus.replace('draft', 'draft_send_back')
            : storeStatus
          : storeStatus + ',sent_to_amc_approver'
        : applicationSentBack
        ? storeStatus.replace('draft', 'draft_send_back')
        : storeStatus,
      storeApplicationType,
      storeModeOfHolding,
      storeDistributorId,
      storeSTPApplicable,
      storeKycModified
    )
  );
  const { applicationType, distributorId, status, modeOfHolding, isSTPApplicable, kycModified } =
    filters;
  const [search, setSearch] = useState(storeSearch);
  const debounceSearchString = useDebounce(search, 500);
  const [distributorLoading, setDistributorLoading] = useState(false);
  const [stampPapersLoading, setStampPapersLoading] = useState(false);
  const [sortDirection, setSortDirection] = useState<'ASC' | 'DESC'>(
    (storeSortDirection as 'ASC' | 'DESC') || 'DESC'
  );
  const [rowsPerPage, setRowsPerPage] = useState(storeRowsPerPage || 10);
  const [nextCursor, setNextCursor] = useState<string | null>(storeNextCursor || null);
  const [prevCursor, setPrevCursor] = useState<string | null>(storePrevCursor || null);
  const [currentCursor, setCurrentCursor] = useState<string | null>(storeCurrentCursor || null);
  const [cursorDirection, setCursorDirection] = useState<CursorDirection>(
    (storeCursorDirection as CursorDirection) || CursorDirection.NEXT
  );
  const [hasNext, setHasNext] = useState(storeHasNext || false);
  const [hasPrev, setHasPrev] = useState(storeHasPrev || false);
  useEffect(() => {
    let componentIsAlive = true;
    setLoading(true);
    setApplicationsList([]);
    (async function () {
      try {
        let response;
        if (paginateCursor) {
          response = (await dispatch(
            getAllApplicationsWithCursor({
              search,
              applicationType: applicationType.toString(),
              distributorId: distributorId.toString(),
              isSTPApplicable: isSTPApplicable.toString(),
              status: status
                .filter(
                  (ele) =>
                    APPLICATION_LISTING_STATUS[ele] !==
                    APPLICATION_LISTING_STATUS.sent_to_amc_approver
                )
                .toString()
                .replace('draft_send_back', 'draft')
                .replace('draft,draft', 'draft'),
              modeOfHolding: modeOfHolding.toString(),
              amcApproverStatus: status.includes('sent_to_amc_approver') ? 'pending' : '',
              applicationSentBack:
                status.includes('draft_send_back') && !status.includes('draft') ? true : null,
              kycModified,
              limit: rowsPerPage,
              order: sortDirection,
              ...(currentCursor
                ? {
                    cursor: currentCursor,
                    direction: cursorDirection,
                  }
                : {}),
            })
          )) as unknown as GetAllApplicantionsResponseBody;
        } else {
          response = (await dispatch(
            getAllApplications({
              search,
              applicationType: applicationType.toString(),
              distributorId: distributorId.toString(),
              isSTPApplicable: isSTPApplicable.toString(),
              status: status
                .filter(
                  (ele) =>
                    APPLICATION_LISTING_STATUS[ele] !==
                    APPLICATION_LISTING_STATUS.sent_to_amc_approver
                )
                .toString()
                .replace('draft_send_back', 'draft')
                .replace('draft,draft', 'draft'),
              modeOfHolding: modeOfHolding.toString(),
              amcApproverStatus: status.includes('sent_to_amc_approver') ? 'pending' : '',
              applicationSentBack:
                status.includes('draft_send_back') && !status.includes('draft') ? true : null,
              kycModified,
              limit: rowsPerPage,
              order: sortDirection,
              page: currentPage,
            })
          )) as unknown as GetAllApplicantionsResponseBody;
        }
        let applications: ApplicationProps[] = [];
        if (Array.isArray(response.data)) {
          applications = response.data as ApplicationProps[];
        } else if (Array.isArray(response.applications)) {
          applications = response.applications as ApplicationProps[];
        } else if (Array.isArray(response)) {
          applications = response as ApplicationProps[];
        } else {
          applications = [];
        }
        const { applications: apps, pages, nextCursor: nextC, prevCursor: prevC } = response || {};
        if (!componentIsAlive) return;
        setApplicationsList(applications);
        setNoPages(pages);
        setPage(1);
        setNextCursor(nextC || '');
        setPrevCursor(prevC || '');
        setHasNext(response.hasNext || false);
        setHasPrev(response.hasPrev || false);
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
        setLoading(false);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, [
    !paginateCursor ? currentPage : null,
    debounceSearchString,
    filters,
    rowsPerPage,
    sortDirection,
    currentCursor,
    cursorDirection,
  ]);

  useEffect(() => {
    let componentIsAlive = true;
    (async function () {
      try {
        setStampPapersLoading(true);

        const stamPaper = (await dispatch(getStampPaperCount())) as unknown as StampPapersType;
        const { series } = stamPaper || {};
        if (!componentIsAlive) {
          return;
        }
        const stamData = series.map((ele) => {
          const lastTwoDigit =
            ele.denomination % (ele.denomination?.toString().length > 2 ? 100 : 10);
          return { ...ele, denomination: ele.denomination - lastTwoDigit };
        });
        setStampCount(stamData);
        setStampPapersLoading(false);

        // Only fetch notification status for AMC_ADMIN role
        if ([USER_ROLES.AMC_ADMIN].includes(role)) {
          const lowStammNotification = (await dispatch(
            getLowStamPaperNotification()
          )) as unknown as GetLowStamPaperNotificationType;

          if (!componentIsAlive) {
            return;
          }
          setNotificationEnabled(lowStammNotification.opted);
        }
      } catch (e) {
        setStampPapersLoading(false);
        console.error((e as Error).message);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, [role]);

  const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event: SelectChangeEvent<number>) => {
    setRowsPerPage(Number(event.target.value));
    setPage(1); // Reset to first page
  };

  const handleFiltersAnchorEl = async () => {
    try {
      setFiltersAnchorEl(true);
      setDistributorLoading(true);
      const distributorList = (await dispatch(
        getDistributorsFilterListing()
      )) as unknown as DistributorFilterList[];
      console.log(distributorList, 'distributorList');
      setDistributors(distributorList);
      setDistributorLoading(false);
    } catch (e) {
      console.error((e as Error).message);
      setDistributorLoading(false);
    }
  };

  const handleFiltersAnchorElClose = () => {
    setFiltersAnchorEl(false);
  };

  const filterOptions = (): JSX.Element => {
    const badgeCount = [
      'applicationType',
      'modeOfHolding',
      'status',
      'distributorId',
      'isSTPApplicable',
      'kycModified',
    ].filter((filterKey) => (filters[filterKey] as string[])?.length)?.length;
    return (
      <>
        <IconButton
          sx={{ p: 0.5 }}
          id="filter-icon-button"
          aria-controls="filter-menu"
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleFiltersAnchorEl}>
          <Badge badgeContent={badgeCount} color="info">
            <CardMedia component="img" image="/images/filter-icon.svg" alt="Filter Icon" />
          </Badge>
        </IconButton>{' '}
        {filtersAnchorEl && (
          <FilterDropdown
            filters={filters}
            onFiltersChange={(value) => {
              setPage(1);
              setFilters(value);
            }}
            anchorEl={filtersAnchorEl}
            handleClose={handleFiltersAnchorElClose}
            distributors={distributors}
            loader={distributorLoading}
          />
        )}
      </>
    );
  };

  const handleNotificationChange = async (checked: boolean) => {
    try {
      const response = (await dispatch(
        lowStampPaperNotification({
          notificationType: 'low_stamp_paper',
          opted: checked,
        })
      )) as unknown as GetLowStamPaperNotificationType;

      setNotificationEnabled(response.opted);
      enqueueSnackbar(`Stamp papers email notification is ${checked ? 'enabled' : 'disabled'}`, {
        variant: checked ? 'success' : 'error',
        autoHideDuration: 1000,
      });
    } catch (error) {
      console.error((error as Error).message);
      setNotificationEnabled(!checked);
    }
  };
  const handleCursorPageChange = (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => {
    // If user clicks next
    if (newPage > currentPage - 1 && nextCursor) {
      setCurrentCursor(nextCursor);
      setCursorDirection(CursorDirection.NEXT);
    }
    // If user clicks prev
    else if (newPage < currentPage - 1 && prevCursor) {
      setCurrentCursor(prevCursor);
      setCursorDirection(CursorDirection.PREV);
    }
    // Optionally update currentPage if you want to show the page number
  };
  return (
    <CommonLayout>
      <>
        <Box>
          <Typography
            component="h2"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 18,
              fontWeight: 500,
              mb: { xs: 2, md: 4 },
              p: { xs: '5px 15px', md: '' },
              bgcolor: '#e5f1f8',
              borderRadius: '10px',
            }}>
            All Applications
          </Typography>
          {[USER_ROLES.AMC_ADMIN, USER_ROLES.RM].includes(role) && (
            <Box
              sx={{
                bgcolor: 'white',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
                borderRadius: '10px',
                width: 'unset',
              }}
              mb={2}>
              <Box pb={3}>
                <Grid container sx={{ pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                  <SubHeading
                    sx={{
                      display: 'flex',
                      mb: 0,
                      alignItems: 'center',
                      justifyContent: [USER_ROLES.AMC_ADMIN].includes(role)
                        ? 'space-between'
                        : 'center',
                      padding: { xs: '10px 15px', sm: '10px 30px' },
                    }}>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: 'primary.main',
                        textAlign: [USER_ROLES.AMC_ADMIN].includes(role) ? 'left' : 'center',
                        width: [USER_ROLES.AMC_ADMIN].includes(role) ? 'auto' : '100%',
                      }}>
                      Stamp Papers Information
                    </Typography>
                    {[USER_ROLES.AMC_ADMIN].includes(role) && (
                      <Switch
                        checked={notificationEnabled}
                        // defaultChecked={false}
                        onChange={(e) => {
                          handleNotificationChange(e.target.checked);
                        }}
                        disabled={stampPapersLoading}
                      />
                    )}
                  </SubHeading>

                  {stampPapersLoading ? (
                    <>
                      <GridItem>
                        <Skeleton />
                      </GridItem>
                      <GridItem>
                        <Skeleton />
                      </GridItem>
                    </>
                  ) : (
                    stampCount.map((action, index) => (
                      <Grid
                        key={index}
                        container
                        direction="row"
                        justifyContent="space-between"
                        sx={{ pl: { xs: 0, sm: 10 }, pr: { xs: 0, sm: 10 } }}
                        alignItems="center"
                        pt={3}>
                        <Typography
                          component="h4"
                          sx={{
                            fontSize: 18,
                            fontWeight: 600,
                            color: 'text.secondary',
                          }}>
                          Denomination: {action.denomination}
                        </Typography>
                        <Typography
                          component="h4"
                          sx={{
                            fontSize: 18,
                            fontWeight: 600,
                            color: 'text.secondary',
                            '&.Draft .MuiTypography-root': {
                              color: '#2a6aa6',
                            },
                            '&.Completed .MuiTypography-root': {
                              fontWeight: 600,
                              color: '#4B8251',
                            },
                            '&.Rejected .MuiTypography-root': {
                              color: '#BD2932',
                              fontWeight: 500,
                            },
                          }}>
                          Unused Stamp Count: {action.unused}
                          <Typography
                            component="span"
                            sx={{
                              color: '#996E09',
                              fontSize: '16px',
                              letterSpacing: '0.4px',
                              ml: 0.5,
                            }}></Typography>
                        </Typography>
                      </Grid>
                    ))
                  )}
                </Grid>
              </Box>
            </Box>
          )}
          <Grid
            container
            sx={{
              p: '20px 30px',
              pb: 0,
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              bgcolor: 'common.white',
              mb: 1.5,
            }}>
            <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
              <Grid item>
                <FormControl variant="standard" sx={{ display: 'block' }}>
                  <InputLabel
                    htmlFor="input-with-icon-adornment"
                    sx={{ '&.Mui-focused': { color: 'text.primary' } }}>
                    Search Application
                  </InputLabel>
                  <Input
                    id="input-with-icon-adornment"
                    value={search}
                    onChange={({ target: { value } }) => {
                      setPage(1);
                      setCurrentCursor(null);
                      setSearch(value);
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton>
                          <SearchSharpIcon sx={{ color: 'primary.main' }} />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              {/* <Grid item sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}> */}
              {/* <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'primary.main', pr: 1 }}>
                Filters :
              </Typography> 
               <Stack direction="row" gap={1} flexWrap="wrap">
                <Chip
                  label="Single"
                  size="small"
                  onDelete={() => console.log('chip deleted')}
                  sx={{
                    bgcolor: 'rgba(41, 49, 57, 0.05)',
                    //  '& .MuiChip-label': { lineHeight: 1 }
                  }}
                />
              </Stack> */}
              {/* </Grid> */}
            </Grid>
            <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  sx={{
                    color: 'primary.main',
                    fontWeight: 500,
                    fontSize: 14,
                    mr: 2.5,
                    p: 1,
                  }}
                  onClick={() => history.push('/onboarding')}>
                  Add Applicant
                </Button>
                {filterOptions()}
                {paginateCursor && (
                  <>
                    <Tooltip title={sortDirection === 'ASC' ? 'Sort Ascending' : 'Sort Descending'}>
                      <span>
                        <IconButton
                          onClick={() => setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC')}
                          sx={{
                            backgroundColor: '#2057A6',
                            borderRadius: '7px',
                            p: 1.4,
                            '&:hover': {
                              backgroundColor: '#174483',
                            },
                          }}>
                          <CardMedia
                            component="img"
                            src="/images/ascending-sort.svg"
                            alt={sortDirection === 'ASC' ? 'Sort Descending' : 'Sort Ascending'}
                            sx={{
                              width: '1.1rem',
                              filter: 'invert(1) brightness(2)',
                              transform:
                                sortDirection === 'ASC'
                                  ? 'rotate(180deg) scaleX(-1)'
                                  : 'rotate(0deg) scaleX(1)',
                              transition: 'transform 0.2s',
                            }}
                          />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </>
                )}
              </Stack>
              <Grid item> </Grid>
            </Grid>
          </Grid>
          <Box>
            <DashboardAndApplicationsList
              isLoading={isLoading}
              applicationsList={applicationsList}
              boxStyles={{ minWidth: 650 }}
            />
          </Box>

          {!!applicationsList.length && (
            <Stack
              direction="row"
              justifyContent={paginateCursor ? 'flex-end' : 'center'}
              sx={{ mt: paginateCursor ? 2 : 5 }}>
              {paginateCursor ? (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    position: 'relative',
                  }}>
                  {/* Empty div for left spacing */}
                  <Box></Box>

                  {/* Centered actions */}
                  <Box
                    sx={{
                      position: 'absolute',
                      left: '50%',
                      transform: 'translateX(-50%)',
                    }}>
                    <CustomTablePaginationActions
                      page={currentPage - 1}
                      onPageChange={handleCursorPageChange}
                      hasNext={hasNext}
                      hasPrev={hasPrev}
                    />
                  </Box>

                  {/* Right side - Rows per page */}
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <Typography sx={{ fontSize: '18px' }}>Rows per page:</Typography>
                    <Select
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPage}
                      size="small"
                      sx={{ fontSize: '18px' }}>
                      {ROWS_PER_PAGE_OPTIONS.map((option) => (
                        <MenuItem key={option} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                </Box>
              ) : (
                <Pagination
                  count={noOfPages}
                  page={currentPage}
                  color="primary"
                  onChange={handlePageChange}
                />
              )}
            </Stack>
          )}
        </Box>
      </>
    </CommonLayout>
  );
}
